import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IMenu } from '../interfaces/menu.model';

@Injectable({
  providedIn: 'root'
})
export class StoreService {

  public storeProfile = new BehaviorSubject<any>(null);
  public optionsListMenu: IMenu[] = [];

  constructor() { }

  get getProfile(): any {
    return this.storeProfile.getValue();
  }

}
